import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 8h8v8","key":"svg-0"}]]

const IconChevronUpRight = createReactComponent('outline', 'chevron-up-right', 'ChevronUpRight', __iconNode);

export default IconChevronUpRight;